import { render, staticRenderFns } from "./WaveSelector.vue?vue&type=template&id=4a06c996&scoped=true"
import script from "./WaveSelector.vue?vue&type=script&lang=js"
export * from "./WaveSelector.vue?vue&type=script&lang=js"
import style0 from "./WaveSelector.vue?vue&type=style&index=0&id=4a06c996&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06c996",
  null
  
)

export default component.exports